import { AccountCircleOutlined, Bolt, LocalShippingOutlined, LocationOnOutlined, PersonOutline } from '@mui/icons-material'
import type { ReactElement } from 'react'

import SolarPanelIcon from './SolarPanelIcon'
import SynopLinkIcon from './SynopLinkIcon'

export type EntityIconKind = 'site' | 'charger' | 'vehicle' | 'user' | 'organization' | 'synopLink' | 'solarArray'

/**
 * The glyph for each platform entity kind wherever entities are listed or picked
 * (the platform search, the workflow scope search), so one kind never reads as
 * two different icons across the app.
 */
const entityIcons: Record<EntityIconKind, ReactElement> = {
  site: <LocationOnOutlined fontSize="small" />,
  charger: <Bolt fontSize="small" />,
  vehicle: <LocalShippingOutlined fontSize="small" />,
  user: <AccountCircleOutlined fontSize="small" />,
  organization: <PersonOutline fontSize="small" />,
  synopLink: <SynopLinkIcon fontSize="small" />,
  solarArray: <SolarPanelIcon fontSize="small" />
}

export default entityIcons
